import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import styles from "./home.module.scss"
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Divider from '@mui/material/Divider';
import TodayScheduleEvents from '../devotee/dashboard/events/todayScheduleEvents';
import SelectDate from '../devotee/dashboard/events/selectDateSchedule';
import { CustomCalendarIcon } from '../common/StyledComponents/StyledFields';
import { apiRequest } from '../../infrastructure/backendService';
import apiPath from "../../config/apiPaths.json";

interface TabPanelProps {
   children?: React.ReactNode;
   index: number;
   value: number;
}


// interface TodayScheduleProps {
//    date: Date;
// }

export default function ScheduleTabs() {
   const [activeTab, setActiveTab] = useState<number>(0);
   const [date, setDate] = useState(new Date());
   const [arrowsHide, setArrowHide] = useState<boolean>(true);
   const [lefticonActive, setLeftIconActive] = useState<boolean>(false);
   const [righticonActive, setRightIconActive] = useState<boolean>(true);
   const [todayScheduleList, setTodayScheduleList] = useState<string[] | []>([]);
   const [error, setError] = useState<string | null>(null);
   const currentDate = new Date();
   const [selectedDate, setSelectedDate] = useState(formatDate(currentDate));
   
   const handleTabClick = (tabIndex: number, toogle: boolean) => {
      setActiveTab(tabIndex);
      setArrowHide(toogle);
   };

   const handleDateChange = (increment: number) => {
      const today = new Date();
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + increment);

      // Calculate the date that is 7 days from today
      const maxDate = new Date(today);
      maxDate.setDate(today.getDate() + 7);

      if (newDate <= today) {
         // The new date is before or equal to today
         setDate(today);
         setLeftIconActive(false); // Disable the previous button
      } else if (newDate > maxDate) {
         // The new date is beyond 7 days from today
         setDate(maxDate);
         setRightIconActive(false); // Disable the next button
      } else {
         setDate(newDate);
         setLeftIconActive(true); // Enable the previous button
         setRightIconActive(true); // Enable the next button
      }
   };
   
   function formatDate(date: Date): string {
      const day = date?.getDate();
      const month = date?.getMonth() + 1;
      const year = date?.getFullYear();

      const formattedDay = day < 10 ? `0${day}` : day;
      const formattedMonth = month < 10 ? `0${month}` : month;

      return `${formattedMonth}/${formattedDay}/${year}`;
   }
   
   useEffect(() => {
      apiRequest({
         method: 'POST',
         endpoint: apiPath.dailyTempleActivity,
         params: {
            scheduleDate: formatDate(date),
         }
      })
         .then((res) => {
            console.log(res.data);
            setTodayScheduleList(res.data.dailyActivities);
            setError(null); // Clear any previous errors
         })
         .catch((err) => {
            console.error(err);
            setError('Network error occurred'); // Set the error message
            // toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
            //    duration: constants.TOAST_POPUP_DURATION,
            //  });
         });
   }, [date]);

   function CustomTabPanel(props: TabPanelProps) {
      const { children, value, index, ...other } = props;

      return (
         <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
         >
            {value === index && (
               <Box sx={{ padding: '10px' }}>
                  <Typography>{children}</Typography>
               </Box>
            )}
         </div>
      );
   }

   return (
      <Box className={styles.scheduleTabContainer}>
         <Box>
            <div className={styles.tabs}>
               <div onClick={() => handleTabClick(0, true)}>
                  {(
                     <ChevronLeftIcon
                        className={
                           arrowsHide ? (lefticonActive
                              ? `${styles.icon} ${styles.active}`
                              : `${styles.icon} ${styles.disable}`) : `${styles.icon} ${styles.disable}`
                        }
                        onClick={() => lefticonActive && handleDateChange(-1)}
                     />
                  )}
                  <div className={`${styles.tab} ${activeTab === 0 ? `${styles.active}` : ''}`}>
                     {' '}
                     Pooja Schedule for Next 7 Days
                  </div>
                  {(
                     <ChevronRightIcon
                        className={
                           arrowsHide ? (righticonActive
                              ? `${styles.icon} ${styles.active}`
                              : `${styles.icon} ${styles.disable}`) : `${styles.icon} ${styles.disable}`
                        }
                        onClick={() => righticonActive && handleDateChange(1)}
                     />
                  )}
               </div>
               <div
                  className={`${styles.tab} ${activeTab === 1 ? `${styles.active}` : ''}`}
                  onClick={() => handleTabClick(1, false)}
               >
                  Select Date
               </div>
               <div
                  style={{ marginTop: "12px" }}
                  onClick={() => handleTabClick(1, !arrowsHide)}
               >
                  <CustomCalendarIcon />
               </div>
            </div>
            <Divider
               sx={{
                  background: '#F2BE224A',
                  height: '1px',
               }}
            />
         </Box>


         <Box sx={{ height: "665px" }} className={styles.SelectScroll}>
            <CustomTabPanel value={activeTab} index={0}>
               <TodayScheduleEvents date={date} todayScheduleList={todayScheduleList} error={error} />
            </CustomTabPanel>
            <CustomTabPanel value={activeTab} index={1}>
               <SelectDate/>
            </CustomTabPanel>
         </Box>
      </Box>
   );
}
